// components/Table.jsx
import React from "react";
import { Link } from "react-router-dom";

const Table = ({
  columns = [],
  data = [],
  keyField = "id",
  rowActions = null,
  openRow = null,
  setOpenRow = () => {},
  dropdownRef = null,
  loading = false,
  emptyMessage = "No data found",
  onRowClick = null,
}) => {
  // Safely handle data - ensure it's always an array
  const tableData = Array.isArray(data) ? data : [];

  return (
    <div className="overflow-x-auto bg-white rounded-md common-scroll mt-6">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-[#F1F6FF] border-b border-[#F3EFEF]">
            {columns.map((column) => (
              <th
                key={column.key}
                className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider"
                style={column.style || {}}
              >
                {column.title}
              </th>
            ))}
            {rowActions && (
              <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">
                Action
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td
                colSpan={columns.length + (rowActions ? 1 : 0)}
                className="px-6 py-4 text-center"
              >
                Loading...
              </td>
            </tr>
          ) : tableData.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length + (rowActions ? 1 : 0)}
                className="px-6 py-4 text-center"
              >
                {emptyMessage}
              </td>
            </tr>
          ) : (
            tableData.map((row, index) => (
              <tr
                key={row[keyField] || index}
                className="group hover:bg-[#F8FAFF] transition-all duration-200 border-b border-[#F3EFEF] last:border-b-0 cursor-pointer"
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns.map((column) => (
                  <td
                    key={column.key}
                    className="px-6 py-4 text-sm font-medium text-gray-900 group-hover:text-blue-600 transition-colors"
                  >
                    {column.render
                      ? column.render(row[column.dataIndex], row, index)
                      : row[column.dataIndex]}
                  </td>
                ))}
                {rowActions && (
                  <td className="px-6 py-4 relative">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenRow(openRow === index ? null : index);
                      }}
                      className="inline-flex items-center justify-center gap-x-2 rounded-md hover:bg-gray-100 px-3 py-1"
                    >
                      {/* threeDotsIcon should be passed from parent or imported */}
                      {rowActions.threeDotsIcon}
                    </button>

                    {openRow === index && (
                      <div
                        ref={dropdownRef}
                        className="absolute dropdown right-2 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-50"
                      >
                        <div className="p-1">
                          {(typeof rowActions.actions === "function"
                            ? rowActions.actions(row)
                            : rowActions.actions
                          ).map((action, actionIndex) => {
                            const label =
                              typeof action.label === "function"
                                ? action.label(row)
                                : action.label;

                            return (
                              <Link
                                key={actionIndex}
                                to={action.to || "#"}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  action.onClick && action.onClick(row, index);
                                  setOpenRow(null);
                                }}
                                className="block dropdown-item px-3 py-2 text-sub_span !font-medium hover:bg-[#4285F4] hover:text-[#DAFA7B] flex gap-2 items-center rounded-md"
                              >
                                {action.icon}
                                {label}
                              </Link>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
